module.exports = __webpack_public_path__ + "fd624c4579db816e479d11083e54eabe.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/GC_PUBLIKUM.jpg
// module id = 885
// module chunks = 0